import React from 'react'

import { Heading } from '../../components'
import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { View } from '../../components/line-stacked-bar-chart'
import { TrafficDataViewEnum, TrafficSettings } from './types'

export function WidgetDomainSettingsSection() {
  const { settings, setSettings } = useFinancialsTableContext<TrafficSettings>()

  const toggleSetting = (key: keyof TrafficSettings, value: TrafficSettings[typeof key]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  return (
    <div className="flex items-center justify-between">
      <Heading level={4} className="text-muted">
        Domains: Monthly Visits
      </Heading>
      <div className="flex h-8 space-x-5">
        <ChipSwitch size="small" label="Data">
          <ChipSwitchButton
            active={settings.trafficDataView === TrafficDataViewEnum.visits}
            onClick={() => {
              toggleSetting('trafficDataView', TrafficDataViewEnum.visits)
            }}
          >
            Visits
          </ChipSwitchButton>
          <ChipSwitchButton
            active={settings.trafficDataView === TrafficDataViewEnum.momChangePct}
            onClick={() => {
              toggleSetting('trafficDataView', TrafficDataViewEnum.momChangePct)
            }}
          >
            MoM Growth %
          </ChipSwitchButton>
        </ChipSwitch>

        <ChipSwitch size="small" label="Chart">
          <ChipSwitchButton
            active={settings.chartView === View.bars}
            leftContent="chartBar"
            size="none"
            className="h-6 w-6"
            onClick={() => {
              toggleSetting('chartView', View.bars)
            }}
          />
          <ChipSwitchButton
            active={settings.chartView === View.lines}
            leftContent="lineChartType"
            size="none"
            className="h-6 w-6"
            onClick={() => {
              toggleSetting('chartView', View.lines)
            }}
          />
        </ChipSwitch>
      </div>
    </div>
  )
}
